import { Button, Text, MessageBar, MessageBarBody, tokens } from '@fluentui/react-components'
import { ArrowClockwise24Regular } from '@fluentui/react-icons'

interface Props {
  isError: boolean
  message: string
  autoRetryCount: number
  autoRetryCountdown: number
  maxRetries: number
  onRetry: () => void
}

export default function ErrorRetryBar({ isError, message, autoRetryCount, autoRetryCountdown, maxRetries, onRetry }: Props) {
  if (!isError) return null
  return (
    <MessageBar intent="warning" style={{ marginBottom: 12 }}>
      <MessageBarBody style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        {message}
        {autoRetryCount < maxRetries && autoRetryCountdown > 0 && (
          <Text size={200} style={{ color: tokens.colorNeutralForeground3 }}>
            Opakuji za {autoRetryCountdown} s ({autoRetryCount + 1}/{maxRetries})
          </Text>
        )}
        <Button size="small" icon={<ArrowClockwise24Regular />} onClick={onRetry}>
          Zkusit znovu
        </Button>
      </MessageBarBody>
    </MessageBar>
  )
}
